export const CHANNEL_TYPE_IMAGES: Record<string, string> = {
    fb: "https://cdn-icons-png.flaticon.com/512/124/124010.png",
    zalo: "https://upload.wikimedia.org/wikipedia/commons/9/91/Icon_of_Zalo.svg",
    zalo_oa: "https://upload.wikimedia.org/wikipedia/commons/9/91/Icon_of_Zalo.svg",
    tiktok: "https://pancake.vn/static/images/Logotiktok3.png",
    instagram: "https://cdn-icons-png.flaticon.com/512/174/174855.png",
};

export const CHANNEL_TYPE_LABELS: Record<string, string> = {
    fb: "Facebook",
    zalo: "Zalo",
    zalo_oa: "Zalo OA",
    tiktok: "TikTok",
    instagram: "Instagram",
};

export const getChannelImage = (code: string) => CHANNEL_TYPE_IMAGES[code] || "https://pancake.vn/static/images/platform_all.jpg";
